import $ from 'jquery';

function printProductStars() {
    $('.product-stars').each(function () {
        var rating = $(this).attr('data-rating')
        var count = $(this).attr('data-count')

        if (!rating || !count) return

        const path = '/products/' + $(this).attr('data-handle')
        try {
            rating = parseFloat(rating)
            count = parseInt(count)
        } catch (e) {
            rating = 0
            count = 0
        }

        if (count === 0) return

        const maxWidthPx = 90
        const widthPercent = rating / 5

        $(this).html('<a href="' + path + '#rapid_reviews_items" tabindex="0" aria-label="Product rating ' + rating + ' of 5 stars"><span class="product-stars-icons" style="width:' + (maxWidthPx * widthPercent) + 'px">&nbsp;</span> (' + count + ')</a>')
    })
}

$(function () {
    printProductStars()
});
